<script setup lang="ts">
import { BarChart } from '@/components/ui/chart-bar'
import { Card } from '@/components/ui/card'
import { computed, onMounted, ref } from 'vue'
import ClientsRepository from '@/repository/ClientsRepository'
import type { GetRepartitionClientsParAgenceViewModel } from '@/lib/types'

const repartitionData = ref<GetRepartitionClientsParAgenceViewModel[]>([])

const filteredData = computed(() => {
  if (!repartitionData.value) return []

  return repartitionData.value.map((item) => ({
    agence_title: item.agence_title,
    'Clients total': item.total_clients,
    'Nouveaux clients societe': item.total_new_clients_societe,
    'Nouveaux clients personne': item.total_new_clients_personne,
  }))
})

onMounted(async () => {
  repartitionData.value = await ClientsRepository.getRepartitionData()
})
</script>

<template>
  <Card
    title="Répartition clients par agence"
    :download-chart="{
      selector: '#chart-container',
      filename: 'repartition-clients.png',
    }"
  >
    <BarChart
      id="chart-container"
      :data="filteredData"
      :index="'agence_title'"
      :categories="['Clients total', 'Nouveaux clients societe', 'Nouveaux clients personne']"
    />
  </Card>
</template>
